// extracted by mini-css-extract-plugin
export default {"locationDataContainer":"stylers_locationDataContainer__tfV4c","topSection":"stylers_topSection__itklO"};